import React, { Component } from 'react'
import { Button, ButtonToolbar, MenuItem, DropdownButton, FormGroup, FormControl, InputGroup, Col }from 'react-bootstrap'
import moment from 'moment'
import { translate } from "react-translate"

@translate("ActionBar")
export default class ActionBar extends Component {

  constructor (props) {
    super(props)

    this.state = {
      words: ''
    }

    this.handleChangeWords = this.handleChangeWords.bind(this);
  }

  handleChangeWords(event) {
    this.setState({words: event.target.value});
  }

  _handleSubmit(e){
    e.preventDefault();
    this.props.searchNotesByForm(this.state.words)
  }

  _renderDate(date){
    moment.locale('es');
    var m = moment(date)
    let day = moment(m).format('MMMM')
    let year = moment(m).format('YYYY')
    return (
      <span>{day} {year}</span>
    )
  }

  render () {

    const { imi, sectors, onSelectSector, t } = this.props

    return (
  		<div className="bar-options">
        <Col md={4} sm={12} xs={12}>
          <div className="imi-info">
            <img className="note-imi-father" src={imi.image_circular ? imi.image_circular : imi.image} />
            <div className="link-download">
              <h2>IMI {this._renderDate(imi.date)}</h2>
              <a target="_blank" href={imi.file}>{t("Descargar_informe")}</a>
            </div>
          </div>
        </Col>
        <div className="col-md-5 col-sm-6 col-xs-7">
          <div className="box-views">
            <FormGroup>
              <InputGroup>
                <FormControl type="text" placeholder={t("Buscar_Contenidos")} value={this.state.words}  onChange={this.handleChangeWords}/>
                <InputGroup.Addon>
                  <i className="fa fa-search" onClick={(e) => this._handleSubmit(e)}></i>
                </InputGroup.Addon>
              </InputGroup>
            </FormGroup>
          </div>
        </div>
				<div className="col-md-3 col-sm-6 col-xs-5">
          <div className="selector">
            { ((sectors.category_type.length > 0) || (sectors.subsidiary_type.length > 0)) ? (
              <DropdownButton title="Division" id="dropdown-basic" onSelect={ onSelectSector }>
                {sectors.category_type.map((item, index) =>
                  <MenuItem className="div-option" eventKey={item.id} key={index}>{item.name}</MenuItem>
                )}
                {sectors.subsidiary_type.map((item, index) =>
                  <MenuItem className="div-option" eventKey={item.id} key={index}>{item.name}</MenuItem>
                )}
              </DropdownButton>
              ) : ''
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Imi/Notes/actionBar.js